import { ArrowIcon } from '@modusign/design-system';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import image from '@app/assets/bulk-request-start-from-template.gif';
import pushDataLayer from '@app/libs/analytics/googleTagManager';
import { modalClose } from '@app/store/modal/actions';

import './BulkRequestCreateModal.scss';

function BulkRequestCreateModal() {
  const dispatch = useDispatch();

  useEffect(() => {
    pushDataLayer({ event: 'viewBulkRequestCreateModal' });
  }, []);

  return (
    <div className="Container Container--max-xs">
      <div className="Card Card--pop box-7x align-center">
        <h3 className="space-5x">
          <strong>대량전송 시작하기</strong>
        </h3>
        <div className="space-3x">
          <img
            alt="템플릿으로 대량전송 시작하기 이미지"
            className="BulkRequestCreateModal__image"
            src={image}
          />
        </div>
        <p className="space-3x">
          대량전송에 사용할 템플릿을 선택해
          <br />
          대량전송 시작하기를 눌러 시작할 수 있습니다.
        </p>
        <div className="space-6x">
          <a
            className="TextBtn TextBtn--underline TextBtn--gray"
            href="https://support.modusign.co.kr/hc/ko/articles/360046780573"
            rel="noopener noreferrer"
            target="_blank"
          >
            대량전송 사용방법 자세히 알아보기
            <ArrowIcon direction="right" ml="2px" />
          </a>
        </div>
        <button
          className="Btn Btn--primary"
          type="button"
          onClick={() => {
            dispatch(modalClose());
          }}
        >
          확인
        </button>
      </div>
    </div>
  );
}

export default BulkRequestCreateModal;
